import $ from "jquery";
import Timer from "@bd-utils/timer";
import BackgroundAudio from "@bd-utils/background-audio";
import Tutorial from "@bd-utils/tutorial";
import CompletionPopup from "@bd-utils/completion-popup";
import LocationInfo from "@bd-utils/location-info";
import PlayersStatus from "@bd-utils/players-status";
import OutroVideo from "@bd-utils/outro-video";
import ChallengeAudio from "@bd-utils/challenge-audio";
import CONFIG from "@bd-core/config";
import fb from "@bd-core/firebase";
import bdjs from "@bd-core/bdjs";
import { getState, store } from "@bd-stores/store";
import bdapi from "@bd-core/bd-api";
import Storage from "@bd-utils/storage";
import {
    setAllRoomIsCompleted,
    updatePlayerPageId,
    updateAttributes,
    removeRoomAnswers,
    getRoomLeader,
    getRoomSelectedCase,
    removeSelectedCase,
} from "@bd-core/firebase-actions";
import {
    setFinished,
    setRoomStatus,
    setTeamAnswers,
    setFinalTeamAnswers,
    getRoomStatus,
    setAllRoomCompleted,
    setIsMiddleState,
    setLeader,
    getPlayers,
    setSelectedCase,
    getLeader,
} from "@bd-stores/game-progress";
import {
    setCurrentPageId,
    setCurrentPageType,
    getCurrentPageId,
    getCurrentPageType,
    currentPageIsMainRoom,
} from "@bd-stores/user-progress";

const GameLogic = {
    initialized: false,
    currentPageType: false,
    currentPageID: false,
    transisitonDuration: 275,

    async init() {
        if ($(".app").length < 1) return false;

        this.outroVideo = new OutroVideo();
        this.completionPopup = new CompletionPopup();
        this.timer = new Timer(this.onTimeOut.bind(this));
        this.tutorial = new Tutorial();
        this.backgroundAudio = new BackgroundAudio();
        this.locationInfo = new LocationInfo();
        this.playersStatus = new PlayersStatus();

        this.outroVideo.init();
        this.completionPopup.init();
        this.timer.init();
        this.backgroundAudio.init();
        this.locationInfo.init();
        this.playersStatus.init();

        this.registerGlobalEvents();
        this.registerGlobalListener();

        // Initialize Firebase
        //-----------------------------------------------------------------------
        try {
            await fb.initializeGame();
        } catch (e) {
            console.error(e);
        }
        //-----------------------------------------------------------------------
    },

    registerGlobalListener() {
        const onRoomStatusChanged = (roomID, roomStatus, roomData) => {
            if (!roomStatus) return;
            const currentPageId = getCurrentPageId();
            const isCurrentPageMainroom = currentPageIsMainRoom();

            const possibleStatuses = [
                "is-status-open",
                "is-status-started",
                "is-status-completed",
            ];

            if (currentPageId == roomID) {
                const $status = $(".js-room-status");
                // prettier-ignore
                $status.removeClass(possibleStatuses);
                $status.addClass(roomStatus);
            }

            if (isCurrentPageMainroom) {
                const $roomItem = $(`.js-room-item[data-page="${roomID}"]`);

                roomStatus == "is-status-completed"
                    ? $roomItem.addClass("is-finished")
                    : $roomItem.removeClass("is-finished");
            }

            if (roomStatus == "is-status-completed") {
                /* Show completion popup */
                const isRoomMiddleState = roomData?.isMiddleState || false;
                const roomAnswers = roomData?.finalAnswers || {};

                this.completionPopup.show(
                    roomID,
                    isRoomMiddleState,
                    roomAnswers,
                );
            } else {
                /*
                 * On status open & started it will check the state of completion popup
                 * status might changed since you can edit them via backend
                 * and when the room is set from finish to open or started, we need to reset the state of completion popup(to unseen)
                 */
                this.completionPopup.maybeResetState(roomID);
            }
        };

        const onRoomDataChanged = (e, eventData) => {
            const currentPageId = getCurrentPageId();
            const isCurrentPageMainroom = currentPageIsMainRoom();
            const roomsData = eventData?.data || false;
            let currentRoomIsFinish = false;
            let currentRoomHasAnswer = false;

            /**
             * @type {BD_StoreGameProgress['teamAnswers']}
             */
            let tmpTeamAnswers = {};

            /**
             * @type {BD_StoreGameProgress['finalTeamAnswers']}
             */
            let tmpFinalTeamAnswers = {};

            /**
             * @type {BD_StoreGameProgress['roomStatus']}
             */
            let tmpRoomStatus = {};

            if (roomsData) {
                $.each(roomsData, (roomID, room) => {
                    // @ts-ignore
                    roomID = isNaN(roomID) ? roomID : parseInt(roomID);

                    //Handle room status changed
                    const roomStatus = room?.status;

                    if (roomStatus) {
                        onRoomStatusChanged(roomID, roomStatus, room);
                        tmpRoomStatus[roomID] = roomStatus;
                    }

                    //handle room answers changed
                    const teamAnswers = room?.answers || {};
                    const finalTeamAnswers = room?.finalAnswers || {};

                    tmpTeamAnswers[roomID] = teamAnswers;
                    tmpFinalTeamAnswers[roomID] = finalTeamAnswers;

                    const isCompleted = roomStatus == "is-status-completed";
                    const isCurrentPage = currentPageId == roomID;

                    if (isCurrentPage) {
                        if (isCompleted) currentRoomIsFinish = true;
                        if (finalTeamAnswers) currentRoomHasAnswer = true;
                    }
                });
            }

            store.dispatch(setTeamAnswers(tmpTeamAnswers));
            store.dispatch(setFinalTeamAnswers(tmpFinalTeamAnswers));
            store.dispatch(setRoomStatus(tmpRoomStatus));

            this.maybeAllRoomCompleted();

            if (!this.initialized) {
                this.initializePage(currentPageId, true);
                this.initialized = true;
            }

            //Set DOM for correct answer
            else if (
                currentRoomIsFinish ||
                currentRoomHasAnswer ||
                isCurrentPageMainroom
            ) {
                const currentTypePage = getCurrentPageType();
                const currComponent = bdjs.getComponent(currentTypePage);
                if (currComponent?.setGameState) currComponent.setGameState();
            }
        };

        const onTeamAttributesChanged = (e, eventData) => {
            const leaderID = eventData?.data?.leader;
            store.dispatch(setLeader(leaderID));
            const isMiddleState = eventData?.data?.isMiddleState || false;
            store.dispatch(setIsMiddleState(isMiddleState));
            const selectedCaseID = eventData?.data?.selectedCase;
            store.dispatch(setSelectedCase(selectedCaseID));

            const nextLeaderID = eventData?.data?.nextLeader;
            if (nextLeaderID) {
                updateAttributes({
                    nextLeader: null,
                    leader: parseInt(nextLeaderID),
                });
            }

            this.playersStatus.render();

            const leader = getPlayers().find((p) => p.userId === leaderID);
            $(".js-selection-leader").css("background-color", leader.colorHex);

            const $selectedRoom = $(
                `.js-room-item[data-page=${selectedCaseID}]`,
            );
            $selectedRoom.removeClass("is-locked");
            $selectedRoom.addClass("is-chosen");

            const isFinished = eventData?.data?.isFinished || false;
            if (!isFinished) return;

            store.dispatch(setFinished(true));
            this.timer.stopTimer();

            bdjs.showLoading();

            setTimeout(() => {
                $(".app").html("");

                setTimeout(() => this.onFinish(), this.transisitonDuration);
            }, this.transisitonDuration);
        };

        const onPlayersDataChanged = (e, eventData) => {
            this.locationInfo.render();
            this.playersStatus.render();

            if (!eventData.data.players) return;

            const players = eventData?.data?.players;
            const leaderID = getLeader();
            const currentPlayer = players.find(
                (p) => p.userId === CONFIG.user.id,
            );

            // Handle case when all players were disconnected and someone reconnects
            if (currentPlayer && currentPlayer.isOnline) {
                const onlinePlayers = players.filter((p) => p.isOnline);
                if (onlinePlayers.length === 1 && currentPlayer.isOnline) {
                    // This is the first player to reconnect
                    const leader = players.find((p) => p.userId === leaderID);
                    if (!leader || !leader.isOnline) {
                        // Assign leader to the reconnected player
                        updateAttributes({
                            leader: parseInt(currentPlayer.userId),
                            nextLeader: null,
                        });
                    }
                }
            }

            if (!leaderID) return;
            const leader = players.find((p) => p.userId === leaderID);

            // Check if leader is offline and update to next leader if needed
            if (leader && !leader.isOnline) {
                $(".js-snackbar").addClass("is-open");
                $(".snackbar__text").text("Leader is offline");
                setTimeout(() => {
                    $(".js-snackbar").removeClass("is-open");
                }, 3000);

                const onlinePlayers = players.filter((p) => p.isOnline);
                if (onlinePlayers.length > 0) {
                    const currentLeaderIndex = players.findIndex(
                        (p) => p.userId === leaderID,
                    );
                    const nextLeaderIndex =
                        (currentLeaderIndex + 1) % players.length;

                    // Find next online player
                    let nextOnlineLeader = null;
                    for (let i = 0; i < players.length; i++) {
                        const potentialLeader =
                            players[(nextLeaderIndex + i) % players.length];
                        if (potentialLeader.isOnline) {
                            nextOnlineLeader = potentialLeader;
                            break;
                        }
                    }

                    if (nextOnlineLeader) {
                        updateAttributes({
                            leader: parseInt(nextOnlineLeader.userId),
                            nextLeader: null,
                        });
                    }
                }
            }

            if (leader.ready === false) {
                removeSelectedCase();

                if (currentPlayer.ready === true) {
                    fb.update(fb.currentPlayerPath, {
                        ready: false,
                    });
                }
            }
        };

        bdjs.listen("bd__playersStateChanged", onPlayersDataChanged);

        // This two listener is essentially the same, because
        // bd__roomDataChanged be triggered even if there's no data inside it,
        // but in case that logic changed, we still be able to init the current
        // page explicitly.with the subscribe function, so it is important to
        // keep it there
        // subscribe(onRoomDataChanged, "isFirebaseInitialized");
        bdjs.listen("bd__roomDataChanged", onRoomDataChanged);

        bdjs.listen("bd__teamAttributeChanged", onTeamAttributesChanged);

        this.listenGameProgressChanged();
    },

    registerGlobalEvents() {
        const $app = $(".app");

        $app.on("click", "[data-change-page]", this.changePage.bind(this));
        $app.on("click", ".js-snackbar-close", () => {
            $(".js-snackbar").removeClass("is-open");
        });

        $(document).on("click", function (e) {
            const $elRoomBrief = $(".roomBrief");

            if ($elRoomBrief.length) {
                /**
                 * Check is element related to current event
                 * @param {HTMLElement} el
                 * @param {typeof e} e
                 * @returns {Boolean}
                 */
                const checkRelatedTarget = (el, e) => el.contains(e.target);

                const shouldClose = !checkRelatedTarget($elRoomBrief[0], e);
                if (shouldClose) $elRoomBrief.removeClass("is-open");
            }
        });

        $(window).on("resize", () => {
            const isFunction =
                typeof window.screenCalculationFunc === "function";
            if (isFunction) window.screenCalculationFunc(); // eslint-disable-line no-undef
        });
    },

    /**
     * This function is to listen an event when game progress was edited from backend
     */
    listenGameProgressChanged() {
        const onGameProgressChanged = (e, eventData) => {
            const shouldClearData = eventData?.data?.clearData || false;
            const needReload = eventData?.data?.needReload || false;
            const removedPlayer = eventData?.data?.removedPlayer || false;
            const teamStatusChangedTo =
                eventData?.data?.teamStatusChangedTo || false;
            const teamCode = eventData?.data?.teamCode || false;

            if (teamStatusChangedTo !== "") {
                bdapi.post("game/change-status", {
                    status: teamStatusChangedTo,
                    code: teamCode,
                });
            }

            if (removedPlayer == CONFIG.user.id) {
                bdapi.post("member/kick-member", {
                    member_id: removedPlayer,
                    from_admin: true,
                });
                window.location.reload();
            }

            if (shouldClearData || needReload) {
                updateAttributes({
                    clearData: null,
                    needReload: null,
                }).then(async () => {
                    /**
                     * Clear all data from previous game. Answers, Popup State
                     */
                    if (shouldClearData) {
                        Storage.remove("states");
                        try {
                            await removeRoomAnswers();
                        } catch (err) {
                            console.error(err);
                        }
                        updatePlayerPageId(null);
                    }

                    if (needReload) window.location.reload();
                });
            }
        };

        bdjs.listen("bd__teamAttributeChanged", onGameProgressChanged);
    },

    async onFinish(isTimeout = false) {
        const video = isTimeout
            ? this.outroVideo.videoTimeout
            : this.outroVideo.videoFinish;

        try {
            if (video) {
                bdjs.hideLoading();
                this.outroVideo.showVideo(isTimeout);

                setTimeout(() => {
                    video.play().catch((error) => {
                        // Autoplay was blocked. Do something
                        console.error("Unable to start auto play", error);
                    });
                }, this.transisitonDuration);
            } else {
                // this.outroVideo.afterPlay();

                const [res] = await bdjs.goAsync(
                    bdapi.post("game/restart-game"),
                );
                const resData = res?.data || {};

                if (resData?.data?.redirect) {
                    bdjs.showLoading();
                    $(".transitionPage").show();
                    setTimeout(
                        () => window.location.replace(resData.data.redirect),
                        1000,
                    );
                    return;
                }
            }
        } catch (error) {
            console.error(error);
        }
    },

    playAudioChallenge() {
        const $audioChallenge = new ChallengeAudio();
        const currentPageId = getCurrentPageId();
        const $audio = $(".js-audio-challenge");

        const hasPlayed = $audio.hasClass("is-played");

        if (!hasPlayed) {
            $audioChallenge.init(currentPageId);
        }
    },

    setNextLeader(leaderID) {
        updateAttributes({
            nextLeader: parseInt(leaderID),
        });
    },

    changePage(e) {
        const $el = $(e.currentTarget);
        const pageId = $el.attr("data-change-page");

        if (
            $el.hasClass("is-locked") ||
            $el.hasClass("is-chosen") ||
            $el.hasClass("is-waiting") ||
            $el.parent().hasClass("is-notready")
        ) {
            return;
        }

        this.goToPage(pageId);
    },

    goToPage(pageId) {
        const currentPageId = getCurrentPageId();
        if (currentPageId == pageId) return;

        bdjs.showLoading();
        $(".site").removeClass("overlay-opened");

        setTimeout(() => {
            this.initializePage(pageId);
        }, this.transisitonDuration);
    },

    async onTimeOut() {
        bdjs.showLoading();

        await bdjs.goAsync(bdapi.post("game/timeout"));

        setTimeout(() => {
            $(".app").html("");

            this.onFinish(true);
        }, this.transisitonDuration);
    },

    async initializePage(pageId, dontUpdate) {
        pageId = isNaN(parseInt(pageId)) ? pageId : parseInt(pageId);
        updatePlayerPageId(pageId);
        const leaderID = await getRoomLeader().then((data) => {
            return data.val();
        });
        const selectedCaseID = await getRoomSelectedCase().then((data) => {
            return data.val();
        });

        const pageData = this.getPageData(pageId);
        const component = bdjs.getComponent(pageData.type);
        const currentPageType = getCurrentPageType();

        if (component) {
            // this.hideComponent();

            if (currentPageType) {
                const prevComponent = bdjs.getComponent(currentPageType);

                if (prevComponent) {
                    prevComponent.destroy();
                }
            }

            store.dispatch(setCurrentPageId(pageId));
            store.dispatch(setCurrentPageType(pageData.type));
            store.dispatch(setLeader(leaderID));
            store.dispatch(setSelectedCase(selectedCaseID));

            component._setData(pageData.data);
            component.init();
            this.locationInfo.render();
            this.playersStatus.render();

            if (!dontUpdate) {
                updatePlayerPageId(pageId);
            }

            this.listenScreenLoading();
            this.tutorial.init();
        } else {
            console.error("Component: Can't find component " + pageData.type);
        }
    },

    getPageData(pageId) {
        let _data = {};

        /**
         * @type {BD_RoomType | undefined}
         */
        let _type = undefined;

        $.each(CONFIG.game.rooms, (index, room) => {
            if (room.id == pageId) {
                _type = room.type;
                _data = room.room;
                return false;
            }
        });

        return {
            type: _type,
            data: _data,
        };
    },

    listenScreenLoading() {
        /**
         * @type {JQuery<HTMLImageElement>}
         */
        const $screenImg = $(".screen__img");

        const isScreenImgExist = $screenImg.length > 0;
        // const currentPageId = getCurrentPageId();

        const onLoaded = () => {
            const isFunction =
                typeof window.screenCalculationFunc === "function";

            if (isScreenImgExist) {
                if (isFunction) window.screenCalculationFunc();
            }

            setTimeout(() => {
                const userProgress = getState().userProgress;
                const isInitialized = userProgress.isFirebaseInitialized;
                if (isInitialized) bdjs.hideLoading();

                // //Setup Tutorial
                // this.tutorial.init(currentPageId);
            }, this.transisitonDuration);
        };

        if (!isScreenImgExist) return onLoaded();
        if ($screenImg[0].complete) return onLoaded();
        $screenImg.on("load", onLoaded);
        $screenImg.on("error", onLoaded);
    },

    maybeAllRoomCompleted() {
        const rooms = CONFIG.game.rooms;
        let isAllRoomCompleted = true;

        $.each(rooms, (index, room) => {
            if (
                room.type === "main-room" ||
                room.type === "no_challenge" ||
                room.type === "hint" ||
                room.type === "audio"
            )
                return true;

            const roomStatus = getRoomStatus(room.id);

            if (roomStatus !== "is-status-completed") {
                isAllRoomCompleted = false;
                return false;
            }
        });

        if (isAllRoomCompleted) {
            setAllRoomIsCompleted(true);
            store.dispatch(setAllRoomCompleted(true));
        }
    },
};

export default GameLogic;
